import React from 'react';
import classNames from 'classnames';
import { Theme } from '@mui/material';
import { colorPalette } from '@qualifio/ui-commons';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${colorPalette.grey.main}`,
    borderRadius: 5,
    backgroundColor: 'white',
    overflow: 'auto',
    height: '100%',
  },
  form: {
    padding: 25,
    position: 'relative',
    boxShadow: 'none',
    overflow: 'auto',
  },
  headerAndFooter: {
    display: 'flex',
    height: 69,
    padding: 14,
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
  },
  header: {
    borderBottom: `1px solid ${colorPalette.grey.main}`,
  },
  footer: {
    borderTop: `1px solid ${colorPalette.grey.main}`,
    marginTop: 'auto',
  },
}));
interface Props {
  children: React.ReactNode;
  className?: string;
}

function Form({ children, className }: Props) {
  const classes = useStyles();
  return <div className={classNames(classes.form, className)}>{children}</div>;
}

function Header({ children, className }: Props) {
  const classes = useStyles();
  return (
    <div className={classNames(classes.headerAndFooter, classes.header, className)}>{children}</div>
  );
}

function Footer({ children, className }: Props) {
  const classes = useStyles();
  return (
    <div className={classNames(classes.headerAndFooter, classes.footer, className)}>{children}</div>
  );
}

export function DetailForm({ children, className }: Props) {
  const classes = useStyles();
  return <div className={classNames(classes.container, className)}>{children}</div>;
}

DetailForm.Form = Form;
DetailForm.Header = Header;
DetailForm.Footer = Footer;
